import {BaseSearchDTO} from "../../global/interfaces";

export interface InventSearchDTO extends BaseSearchDTO {
  filters?: InventSearchFilters;
}

export interface InventSearchFilters {
  inventUserId: string;
  searchTerm?: string;
  dateFrom?: Date;
  dateTo?: Date;
}

export interface InventAuctionSearchDTO extends BaseSearchDTO {
  filters?: InventAuctionSearchFilters;
}

export interface InventAuctionSearchFilters {
  searchTerm?: string;
  auctionType?: string;
  auctionLocation?: string;
  dateFrom?: Date;
  dateTo?: Date;
  activityStatus?: number;
}
